import {
    EmailForm,
    RadioForm,
    TelForm,
    TextAreaForm,
    TextForm
} from "./components/forms";


export const formEnum = {
    string:TextForm,
    textarea:TextAreaForm,
    email:EmailForm,
    tel:TelForm,
    choice:RadioForm
}